var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',{staticClass:"hex",class:{ skelly: !_vm.init },attrs:{"transform":_vm.translate},on:{"click":_vm.add}},[_c('polygon',{attrs:{"points":_vm.points}}),_c('text',{staticClass:"letter",attrs:{"x":this.width / 2,"y":this.height / 2}},[_vm._v(_vm._s(_vm.letter))])])
}
var staticRenderFns = []

export { render, staticRenderFns }